import React, {Component} from 'react';
import axios from "axios";
import Select from "react-select";
import Form from "react-bootstrap/Form";

import './SeedInput.css';
import apiUrl from "../../../shared/config";
import {styleRedShadow, selectRedShadow} from "../../../utils/commonStyles";

class SeedInput extends Component  {
    state = {
        seed_exercises: null
    };

    componentDidMount() {
        if (!this.state.seed_exercises) {
            // This seems a little weird, but we want the exercises list here to populate the dropdown.
            // The seed text is then entered by the user. The back end will look at the parts of the seed
            // and if there is a duplicate it will use the existing id.
            axios.get(apiUrl +'Exercises/getExercises')
                .then(response => {
                    this.setState({seed_exercises: response.data});
                });
        }
    }

    arraySearch(arr,val) {
        for (let i = 0; i < arr.length; i++) {
            //console.log('VALUE: ', val, ' ITEM VAL: ', arr[i].value);
            if (arr[i].value === val)
                return i;
        }
        return -1;
    }

    render() {
        let seedInputElement = null;
        if (this.state.seed_exercises) {
            //console.log('SEED EXERCISEs: ' + this.state.seed_exercises.exercises_array);
            const exercisesOptions = this.state.seed_exercises.exercises_array
                .map( seed_exercises => ({value: seed_exercises.exercise_id, label: seed_exercises.exercise_name}));
            const current_index = this.arraySearch(exercisesOptions, this.props.exercise_id);
            const current_value = exercisesOptions[current_index];

            seedInputElement = (
                <dl className="row">
                    <dt className="col-sm-3"><label>Pattern Seed</label></dt>
                    <dd className="col-sm-9">
                        <Select
                            styles={selectRedShadow(current_value || (!current_value && !this.props.seed))}
                            className="seed-exercise-select"
                            value={current_value}
                            options={exercisesOptions}
                            closeMenuOnSelect={true}
                            onChange={(val) => {this.props.exerciseUpdate(val)}}
                        />
                        <div className="seed-input">
                            <Form.Control
                                style={styleRedShadow(this.props.seed || (!current_value && !this.props.seed))}
                                type="text"
                                placeholder="What technique did you begin with?"
                                value={this.props.seed || ""}
                                onChange={(event) => {this.props.seedUpdate(event.target.value);}} />
                        </div>
                    </dd>
                </dl>
            );
        }

        return seedInputElement;
    }
}

export default SeedInput;